import React from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import { Filter, TextField, useFilter, DatePicker } from 'elentari'
import UsuarioAutocomplete from '../../Usuarios/UsuarioAutocomplete'
import { TarefaStatusEnum } from '../TarefaStatus'
import { CustomAutocomplete } from '../../../components'
import { parseCpf, parsePlaca } from '../../../utils/Parse'

const TarefaAnalistaFilter = () => {
  const filter = useFilter({})

  const detailedFilter = () => (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={3}>
        <Field
          fullWidth
          component={DatePicker}
          label="Data Criação De"
          name="createdAt"
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Field
          fullWidth
          component={DatePicker}
          label="Data Criação Até"
          name="createdAtFim"
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Field
          fullWidth
          component={DatePicker}
          label="Data Término De"
          name="dataTermino"
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Field
          fullWidth
          component={DatePicker}
          label="Data Término Até"
          name="dataTerminoFim"
        />
      </Grid>
    </Grid>
  )
  return (
    <Filter
      {...filter}
      detailedFilter={detailedFilter()}
      labels={{
        detailedFilter: 'Busca avançada',
        simpleFilter: 'Busca simples',
        find: 'Buscar',
        clear: 'Limpar'
      }}
    >
      <Grid spacing={3} container>
        <Grid item md={1} xs={12}>
          <Field
            fullWidth
            name="ordemCarregamento"
            label="OC/SD"
            component={TextField}
          />
        </Grid>
        <Grid item md={2} xs={12}>
          <Field
            fullWidth
            component={TextField}
            label="Placa Cavalo"
            parse={parsePlaca}
            name="placaCavalo"
          />
        </Grid>
        <Grid item md={3} xs={12}>
          <Field
            fullWidth
            component={TextField}
            label="CPF"
            parse={parseCpf}
            name="cpfMotorista"
          />
        </Grid>
        <Grid item md={3} xs={12}>
          <Field
            fullWidth
            name="responsavelId"
            label="Responsável"
            component={UsuarioAutocomplete}
            realm="analistaOpAdmin"
          />
        </Grid>
        <Grid item md={3} xs={12}>
          <Field
            fullWidth
            options={Object.values(TarefaStatusEnum).map(status => ({
              label: status,
              value: status
            }))}
            name="status"
            label="Status"
            component={CustomAutocomplete}
          />
        </Grid>
      </Grid>
    </Filter>
  )
}

export default TarefaAnalistaFilter
